import { useEffect } from "react";

export const SITE_URL = "https://waerme-kraft-promotion.com";
const DEFAULT_OG =
  "https://static.prod-images.emergentagent.com/jobs/8e562339-1cc4-4f25-a790-1bdfea68bf5c/images/47f77b9f5ff98d3a8f4f05bdb3d8c5f5c457d6be4092899e8d2349c911006c41.png";

function upsert(selector, tag, attrs, contentAttr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(tag);
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute(contentAttr, value);
}

export function Seo({ title, description, path = "/", image, jsonLd, noindex = false }) {
  useEffect(() => {
    const url = SITE_URL + path;
    const desc = description || "";
    const img = image || DEFAULT_OG;

    if (title) document.title = title;

    upsert('meta[name="description"]', "meta", { name: "description" }, "content", desc);
    upsert('link[rel="canonical"]', "link", { rel: "canonical" }, "href", url);
    upsert(
      'meta[name="robots"]',
      "meta",
      { name: "robots" },
      "content",
      noindex ? "noindex, nofollow" : "index, follow"
    );

    upsert('meta[property="og:type"]', "meta", { property: "og:type" }, "content", "website");
    upsert('meta[property="og:title"]', "meta", { property: "og:title" }, "content", title || "");
    upsert('meta[property="og:description"]', "meta", { property: "og:description" }, "content", desc);
    upsert('meta[property="og:url"]', "meta", { property: "og:url" }, "content", url);
    upsert('meta[property="og:image"]', "meta", { property: "og:image" }, "content", img);

    upsert('meta[name="twitter:card"]', "meta", { name: "twitter:card" }, "content", "summary_large_image");
    upsert('meta[name="twitter:title"]', "meta", { name: "twitter:title" }, "content", title || "");
    upsert('meta[name="twitter:description"]', "meta", { name: "twitter:description" }, "content", desc);
    upsert('meta[name="twitter:image"]', "meta", { name: "twitter:image" }, "content", img);

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo-jsonld", "true");
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      if (script && script.parentNode) script.parentNode.removeChild(script);
    };
  }, [title, description, path, image, jsonLd, noindex]);

  return null;
}
